import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

const ScrollFAB = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      data-testid="scroll-to-top-btn"
      className={`fixed bottom-6 right-6 z-40 w-11 h-11 rounded-full bg-[#D4AF37] text-[#0A0B0E] flex items-center justify-center shadow-lg shadow-[#D4AF37]/20 transition-all duration-300 ease-out hover:scale-110 hover:shadow-xl ${
        show ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-3 scale-75 pointer-events-none'
      }`}
      aria-label="Scroll to top"
    >
      <ArrowUp size={18} strokeWidth={2.5} />
    </button>
  );
};

export default ScrollFAB;
